import { Button, Result } from 'antd'
import { ResultProps } from 'antd/lib/result'

import { history } from '../../redux/store'
export interface Props extends ResultProps {
  onClose: () => void
}
export default function SuccessResult(props: Props) {
  const jumpTaskCenter = () => {
    history.push('/srm/taskcenter')
  }

  const { onClose } = props
  return (
    <Result
      status="success"
      title="提交成功"
      subTitle="您的导入任务已经移交至任务中心，请耐心等待导入成功后，前往待提交物料列表批量提交审核即可"
      extra={[
        <Button key="buy" size="middle" onClick={onClose}>
          关闭
        </Button>,
        <Button
          type="primary"
          size="middle"
          key="console"
          onClick={jumpTaskCenter}
        >
          前往查看
        </Button>,
      ]}
      {...props}
    />
  )
}
import { Button, Result } from 'antd'
import { ResultProps } from 'antd/lib/result'

import { history } from '../../redux/store'
export interface Props extends ResultProps {
  onClose: () => void
}
export default function SuccessResult(props: Props) {
  const jumpTaskCenter = () => {
    history.push('/srm/taskcenter')
  }

  const { onClose } = props
  return (
    <Result
      status="success"
      title="提交成功"
      subTitle="您的导入任务已经移交至任务中心，请耐心等待导入成功后，前往待提交物料列表批量提交审核即可"
      extra={[
        <Button key="buy" size="middle" onClick={onClose}>
          关闭
        </Button>,
        <Button
          type="primary"
          size="middle"
          key="console"
          onClick={jumpTaskCenter}
        >
          前往查看
        </Button>,
      ]}
      {...props}
    />
  )
}
